import SecondaryPageLayout from '@/layouts/SecondaryPageLayout'
import Username from '@/components/Username'
import { forwardRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const AboutPage = forwardRef(({ index }: { index?: number }, ref) => {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = t('About | {{appName}}', { appName: window.hallway.universe.appName })
    history.replaceState(null, '')
  }, [])

  return (
    <SecondaryPageLayout ref={ref} index={index} title={t('About')} hideBackButton>
      <div className="p-4 space-y-4">
        <div className="text-xl font-semibold">Hallway</div>
        <div className="text-muted-foreground">
          A client made for customizable relay-based communities.
        </div>
        <div>
          Made by{' '}
          <Username
            userId="3bf0c63fcb93463407af97a5e5ee64fa883d107ef9e558472c4eb9aaaefa459d"
            className="inline-block text-primary"
          />
          .
        </div>
        <div>
          Here's the{' '}
          <a
            href="https://viewsource.win/fiatjaf.com/hallway"
            target="_blank"
            rel="noreferrer"
            className="text-primary hover:underline"
          >
            source code
          </a>
          .
        </div>
        <div>
          It is also integrated in{' '}
          <a
            href="https://github.com/fiatjaf/pyramid"
            target="_blank"
            rel="noreferrer"
            className="text-primary hover:underline"
          >
            Pyramid
          </a>
          .
        </div>
        <div>
          Current commit:{' '}
          <span className="font-mono text-sm text-muted-foreground">
            {import.meta.env.GIT_COMMIT}
          </span>
        </div>
      </div>
    </SecondaryPageLayout>
  )
})
AboutPage.displayName = 'AboutPage'
export default AboutPage
